import { EyeOutlined } from '@ant-design/icons'
import { Button, Space } from 'antd'
import ButtonGroup from 'antd/es/button/button-group'
import { FC } from 'react'
import PreviewShipmentBlank from '../../../../../../components/buttons/preview-shipment-blank/preview-shipment-blank'
import RoleGuard from '../../../../../../components/role-guard/role-guard'
import PrintJob from '../../../../../../types/api/print-job'
import { PRINT_PLAN_EDIT_ROLES } from '../../../constants/print-plan-edit-roles'
import { CreatedPrintJobsTab } from '../types'
import AddToMachineQueue from './add-to-machine-queue/add-to-machine-queue'

interface ActionsCellProps {
    printJob: PrintJob
    tab: CreatedPrintJobsTab
}

const ActionsCell: FC<ActionsCellProps> = ({ printJob, tab }) => {
    return (
        <RoleGuard requiredRoles={PRINT_PLAN_EDIT_ROLES}>
            <Space>
                <ButtonGroup>
                    <PreviewShipmentBlank
                        shipment={printJob.shipment!}
                        blankType="production"
                        blankPreviewFiles={printJob.shipment?.blankPreviewFiles}
                    >
                        <Button
                            title={'Посмотреть бланк'}
                            size={'small'}
                            icon={<EyeOutlined />}
                            color={'magenta'}
                            variant={'solid'}
                        />
                    </PreviewShipmentBlank>
                    {/* <Button
                        title={'Смотреть тех карту'}
                        size={'small'}
                        icon={<EyeOutlined />}
                        color={'cyan'}
                        variant={'solid'}
                    /> */}
                </ButtonGroup>
                {/* TODO: добавить групповое перетаскивание и групповой перенос на другой станок */}
                <AddToMachineQueue printJob={printJob} tab={tab} />
            </Space>
        </RoleGuard>
    )
}

export default ActionsCell
